export default "/static/bioshake_q1_tiny.png";